import { Box, Typography, Paper } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}

export default function EmptyState({ title, description, action, icon }: Props) {
  return (
    <Paper
      sx={{
        p: 6,
        textAlign: 'center',
        border: (t) => `1px dashed ${t.palette.divider}`,
        boxShadow: 'none',
      }}
    >
      {icon && <Box sx={{ mb: 2, fontSize: 56, opacity: 0.6 }}>{icon}</Box>}
      <Typography variant="h6">{title}</Typography>
      {description && (
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          {description}
        </Typography>
      )}
      {action && <Box sx={{ mt: 3 }}>{action}</Box>}
    </Paper>
  );
}
